import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://cukkuapowreglfksnmtt.supabase.co';
const supabaseKey = 'sb_publishable_p9eSRhylF1ao_WLmT8sWCQ_L7p0D5GG';

export const supabase = createClient(supabaseUrl, supabaseKey);